<template>
  <div>
    <a-spin :spinning="loading">
      <a-layout>
        <a-layout-content style="background: white;">
          <div id="workArea" :gutter="[1,1]">
            <analytics-chart-component v-for="component in setup.componentes"
                                       :options.sync="component.options"
                                       :height="setup.chartHeight"
                                       :width="setup.chartWidth"
                                       :idx="component.idx"
                                       :showHeader="false"
                                       :key="component.idx"></analytics-chart-component>
          </div>
        </a-layout-content>
      </a-layout>
    </a-spin>

    <a-card>
      <a-row :gutter="[1,1]" :md="6" :xs="24">
        <a-form-model :model="filterParams" v-bind="fiOptions" ref="filterForm">
          <a-col v-bind="colOptionsHours">
            <a-form-model-item :rules="[{ required: true, message: 'Valor requerido' }]" v-bind="fiOptions"
                               :label="$t('Año')" style="width: 100%" prop="anio" has-feedback>
              <a-select v-model="filterParams.anio" style="width: 100%">
                <a-select-option v-for="year_ in years" :key="year_" style="width: 100%">
                  {{ year_ }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colOptionsHours">
            <a-form-model-item :label="$t('Sede')">
              <form-model-dropdown style="width: 100%"
                                   v-model="filterParams.id_h_att1"
                                   :params="{h_lookup_type: 'ID_H_ATT1'}"
                                   endpoint="hierarchy_lookup">
              </form-model-dropdown>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colOptionsHours">
            <a-button type="primary"
                      @click="filtrar()"
                      icon="search"
                      style="width: 90px; margin-right: 8px">
              Buscar
            </a-button>
          </a-col>
        </a-form-model>
      </a-row>
      <div style="margin-top: 8px"></div>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="Horas extra" key="1">
          <g-master :name="master.endpoint"
                    :endpoint="master.endpoint"
                    :actions="false"
                    :tableSetup="master.tableSetup"
                    :parentData="parentData"
                    modalWidth="80%"
                    @params="paramsTableExcelHextra"

          >
          <template slot="customButton">
            <g-btn-excel :endpoint="endpointExcelHextra" :params="paramsExcel" :fileName="fileNameExcelHextra"/>
          </template>
          </g-master>
        </a-tab-pane>
        <a-tab-pane tab="Recargos" key="2">
          <g-master :name="masterRecargo.endpoint"
                    :endpoint="masterRecargo.endpoint"
                    :actions="false"
                    :tableSetup="masterRecargo.tableSetup"
                    :parentData="parentData"
                    modalWidth="80%"
                    @params="paramsTableExcelRecargo"
          >
          <template slot="customButton">
            <g-btn-excel :endpoint="endpointExcelRecargos" :params="paramsExcelRec" :fileName="fileNameExcelRecargos"/>
          </template>
          </g-master>
        </a-tab-pane>
      </a-tabs>
    </a-card>
    <a-card>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="Detalle de horas" key="1">
          <a-alert
            v-if="nomenclature != null"
            type="info" showIcon>
            <div slot="message">
              <div v-html="nomenclature"></div>
            </div>
          </a-alert>
          <br/>

          <a-row :gutter="[1,1]" :md="12" :xs="24">
            <a-form-model :model="filterParamsDetalle" v-bind="fiOptions" ref="filterFormDetail">
              <a-col v-bind="colOptions">
                <a-form-model-item :label="$t('Sede')" :rules="[{ required: true, message: 'Valor requerido' }]"
                                   prop="id_h_att1">
                  <form-model-dropdown style="width: 100%"
                                       v-model="filterParamsDetalle.id_h_att1"
                                       :params="{h_lookup_type: 'ID_H_ATT1'}"
                                       endpoint="hierarchy_lookup">
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-model-item :label="$t('Seccion')">
                  <form-model-dropdown style="width: 100%"
                                       v-model="filterParamsDetalle.id_h_att2"
                                       :params="puestoParams"
                                       endpoint="hierarchy_lookup">
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colOptions">
                <a-form-model-item prop="date_mark_ini" :label="$t('Rango')"
                                   :rules="[{ required: true, message: 'Valor requerido' }]">
                  <a-range-picker style="width: 100%" v-model="filterParamsDetalle.date_mark_ini"/>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-button type="primary"
                          @click="filtrarDetalle()"
                          icon="search"
                          style="width: 90px; margin-right: 8px">
                  Buscar
                </a-button>
              </a-col>
            </a-form-model>
          </a-row>
          <g-master :name="masterDetalleHoras.endpoint"
                    :endpoint="masterDetalleHoras.endpoint"
                    :actions="false"
                    :tableSetup="masterDetalleHoras.tableSetup"
                    :parentData="parentDataDetalle"
                    modalWidth="80%"
                    @params="paramsTableExcelDetHoras"
          >
              <template slot="customButton">
                <g-btn-excel :endpoint="endpointExcelDetHoras" :params="paramsExcelDetHor" :fileName="fileNameExcelDetHoras"/>
              </template>
          </g-master>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>
<script>
  import Sortable from 'sortablejs'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        grupo: null,
        puesto: null,
        date_mark_ini: undefined,
        yearToday: parseInt(moment().format('YYYY')),
        years: [],
        idHAtt1Selected: null,
        colOptions: {xs: 24, sm: 12},
        colOptionsHours: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {span: 4},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        setup: {
          componentes: [],
          chartHeight: 300,
          chartWidth: 500
        },
        filterParams: {
          anio: null,
          id_h_att1: null
        },
        yearToSerach: null,
        loading: false,
        filterParamsDetalle: {
          id_h_att1: null,
          id_h_att2: null,
          date_mark_ini: undefined
        },
        nomenclature: null,
        master: {
          endpoint: 'extra_time_store',
          tableSetup: {
            actions: false,
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Sede', dataIndex: 'seccion', sorter: true},
              {title: 'Enero', dataIndex: 'enero', sorter: true},
              {title: 'Febrero', dataIndex: 'febrero', sorter: true},
              {title: 'Marzo', dataIndex: 'marzo', sorter: true},
              {title: 'Abril', dataIndex: 'abril', sorter: true},
              {title: 'Mayo', dataIndex: 'mayo', sorter: true},
              {title: 'Junio', dataIndex: 'junio', sorter: true},
              {title: 'Julio', dataIndex: 'julio', sorter: true},
              {title: 'Agosto', dataIndex: 'agosto', sorter: true},
              {title: 'Septiembre', dataIndex: 'septiembre', sorter: true},
              {title: 'Octubre', dataIndex: 'octubre', sorter: true},
              {title: 'Noviembre', dataIndex: 'noviembre', sorter: true},
              {title: 'Diciembre', dataIndex: 'diciembre', sorter: true}
            ]
          }
        },
        masterRecargo: {
          endpoint: 'extra_time_store_rc',
          tableSetup: {
            actions: false,
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Sede', dataIndex: 'seccion', sorter: true},
              {title: 'Enero', dataIndex: 'enero', sorter: true},
              {title: 'Febrero', dataIndex: 'febrero', sorter: true},
              {title: 'Marzo', dataIndex: 'marzo', sorter: true},
              {title: 'Abril', dataIndex: 'abril', sorter: true},
              {title: 'Mayo', dataIndex: 'mayo', sorter: true},
              {title: 'Junio', dataIndex: 'junio', sorter: true},
              {title: 'Julio', dataIndex: 'julio', sorter: true},
              {title: 'Agosto', dataIndex: 'agosto', sorter: true},
              {title: 'Septiembre', dataIndex: 'septiembre', sorter: true},
              {title: 'Octubre', dataIndex: 'octubre', sorter: true},
              {title: 'Noviembre', dataIndex: 'noviembre', sorter: true},
              {title: 'Diciembre', dataIndex: 'diciembre', sorter: true}
            ]
          }
        },
        masterDetalleHoras: {
          endpoint: 'extra_time_query',
          tableSetup: {
            actions: false,
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Nombre', dataIndex: 'nombre', sorter: true},
              {title: 'Cargo', dataIndex: 'cargo', sorter: true},
              {title: 'Hed', dataIndex: 'hed', sorter: true},
              {title: 'Hedf', dataIndex: 'hedf', sorter: true},
              {title: 'Hen', dataIndex: 'hen', sorter: true},
              {title: 'Henf', dataIndex: 'henf', sorter: true},
              {title: 'Total Extra', dataIndex: 'totalextra', sorter: true},
              {title: 'Rdd', dataIndex: 'rdd', sorter: true},
              {title: 'Rdn', dataIndex: 'rdn', sorter: true},
              {title: 'Rfd', dataIndex: 'rfd', sorter: true},
              {title: 'Rfn', dataIndex: 'rfn', sorter: true},
              {title: 'Rn', dataIndex: 'rn', sorter: true},
              {title: 'Total Recargo', dataIndex: 'totalrecargo', sorter: true}
            ]
          }
        },
        endpointExcelHextra: 'extra_time_store_/downloadExcel',
        paramsExcelHextra: {},
        fileNameExcelHextra: "Horas_Extra",

        endpointExcelRecargos: 'extra_time_store_rc_/downloadExcel',
        paramsExcelRecargos: {},
        fileNameExcelRecargos: "Recargos",

        endpointExcelDetHoras: 'extra_time_query_/downloadExcel',
        paramsExcelDetHoras: {},
        fileNameExcelDetHoras: "Detalle_Horas",
        
      }
    },
    mounted () {
      this.yearsSelect()
      let el = document.getElementById('workArea')
      this.sortable = Sortable.create(el, {
        animation: 150,
        ghostClass: 'blue-background-class'
      })
      this.httpClient = new HttpUtil('analytics_presets')
      this.httpClient.getInstance().get('analytics_presets')
        .then(response => {
          const resultado = response.data.find(obj => obj.name === 'GH LA MONTAÑA')
          this.setup = JSON.parse(resultado.preset_setup)
        })
        .catch(error => {
        })
        .then(() => {
        })

      this.httpClient.getInstance().get('extra_time_nomenclature')
        .then(response => {
          this.nomenclature = response.data['MENSAJE_NOMENCLATURA_HE_RC']
        })
        .catch(error => {
        })
        .then(() => {
        })
    },
    methods: {
      filtrar () {
        this.$refs.filterForm.validate(valid => {
          if (valid) {
            this.yearToSerach = this.filterParams.anio
            this.idHAtt1Selected = this.filterParams.id_h_att1
          }
        })
      },
      filtrarDetalle () {
        this.$refs.filterFormDetail.validate(valid => {
          if (valid) {
            this.grupo = this.filterParamsDetalle.id_h_att1
            this.puesto = this.filterParamsDetalle.id_h_att2
            this.date_mark_ini = this.filterParamsDetalle.date_mark_ini
          }
        })
      },
      yearsSelect () {
        for (let i = 2024; i <= (this.yearToday); i++) {
          this.years.push(i)
        }
      },
      paramsTableExcelHextra (params) {
        this.paramsExcelHextra = params
      },
      paramsTableExcelRecargo (params) {
        this.paramsExcelRecargos = params
      },
      paramsTableExcelDetHoras (params) {
        this.paramsExcelDetHoras = params
      }
    },
    computed: {
      parentData () {
        let finalFilter = {
          anio: this.yearToSerach
        }
        if (this.idHAtt1Selected != null) {
          finalFilter = {
            anio: this.yearToSerach,
            id_h_att1: this.idHAtt1Selected
          }
        }
        return finalFilter
      },
      parentDataDetalle () {
        let finalFilter = {
          id_h_att1: this.grupo,
          date_mark_ini: this.date_mark_ini
        }
        if (this.puesto != null) {
          finalFilter = {
            id_h_att1: this.grupo,
            id_h_att2: this.puesto,
            date_mark_ini: this.date_mark_ini
          }
        }
        return finalFilter
      },
      puestoParams () {
        return {
          h_lookup_type: 'ID_H_ATT2',
          id_h_lookup_father: this.filterParamsDetalle.id_h_att1 ? this.filterParamsDetalle.id_h_att1 : -1
        }
      },
      paramsExcel () {
        return {...this.paramsExcelHextra, columns: this.master.tableSetup.columns, ...{
            anio: this.yearToSerach,
            id_h_att1: this.idHAtt1Selected
          }}
      },
      paramsExcelRec () {
        return {...this.paramsExcelRecargos, columns: this.masterRecargo.tableSetup.columns, ...{
            anio: this.yearToSerach,
            id_h_att1: this.idHAtt1Selected
          }}
      },
      paramsExcelDetHor(){
        let finalFilter = {
          id_h_att1: this.grupo,
          date_mark_ini: this.date_mark_ini
        }
        if (this.puesto != null) {
          finalFilter = {
            id_h_att1: this.grupo,
            id_h_att2: this.puesto,
            date_mark_ini: this.date_mark_ini
          }
        }
        return {...this.paramsExcelDetHoras, columns: this.masterDetalleHoras.tableSetup.columns, ...finalFilter}
      }
    }
  }
</script>
<style>
  .blue-background-class {
    background: rgba(0, 0, 255, 0.1);
  }
</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/RecargosYNovedades/Recargos.vue